import api from '@/helpers/api'
import axios from '@/helpers/axios'

export default {
    namespaced: true,

    state: {
        progress: [],
    },

    getters: {
        progress: state => state.progress,
    },

    mutations: {
        ADD_TO_PROGRESS(state, item) {
            if(!state.progress.includes(item))
            {
                state.progress.push(item)
                axios.post(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/progress/grant-application', {'progress': state.progress})
            }
        },
        REMOVE_FROM_PROGRESS(state, item) {
            state.progress = state.progress.filter(function(value){
                return value !== item
            });
            axios.post(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/progress/grant-application', {'progress': state.progress})
        },
        INITIALIZE_PROGRESS(state) {
            axios.get(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/progress/grant-application')
                .then(response => {
                        state.progress = response.data.progress ? response.data.progress : []
                })
        }
    },

    actions: {
        addToProgress({ commit }, item) {
            commit('ADD_TO_PROGRESS', item)
        },

        removeFromProgress({ commit }, item) {
            commit('REMOVE_FROM_PROGRESS', item)
        },
        initializeProgress({commit}) {
            commit('INITIALIZE_PROGRESS')
        }
    },
}
